import Modal from 'components/common/Modal';
import styled from 'styled-components';
import celebrationEmoji from 'assets/celebration_emoji.png';
import { buttonStyle } from 'lib/styles/index';
import { MdErrorOutline } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { initializeRegisterInputs } from 'modules/serviceSlice';

const NotiModal = ({ fail, closeModal }) => {
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(initializeRegisterInputs());
    closeModal();
  };

  const onExit = () => {
    window.close();
  };

  return (
    <Modal>
      <NotiModalBlock>
        {fail ? (
          <>
            <MdErrorOutline className="icon" />
            <div>서버 오류가 발생했습니다!</div>
            <button onClick={onClose}>확인</button>
          </>
        ) : (
          <>
            <img src={celebrationEmoji} alt="celebration" />
            <div>가입에 성공했습니다!</div>
            <button onClick={onExit}>확인</button>
          </>
        )}
      </NotiModalBlock>
    </Modal>
  );
};

export default NotiModal;

const NotiModalBlock = styled.div`
  padding: 2rem 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;

  img,
  .icon {
    font-size: 42px;
    width: 40px;
    margin-bottom: 1rem;
  }

  div {
    margin-bottom: 1rem;
  }

  button {
    ${buttonStyle}
  }
`;
